import { useEffect } from 'react';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';
import { withFlags } from '@confluence/flags/entry-points/withFlags';

import { useSetBulkCreateFlagsContainer } from '../../providers/AiBulkNavigationContextProvider';

type BulkCreateFlagsContainerProps = {
	flags: FlagsStateContainer;
};

const BulkCreateFlagsContainerComponent = ({ flags }: BulkCreateFlagsContainerProps) => {
	const setFlags = useSetBulkCreateFlagsContainer();

	useEffect(() => {
		setFlags(flags);
	}, [flags, setFlags]);

	return null;
};

export const BulkCreateFlagsContainer = withFlags(BulkCreateFlagsContainerComponent);
